import {useEffect, useState, useRef} from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import moment from 'moment';
import {PuffLoader} from 'react-spinners';
import {TableWrapper} from '../../components/TableWrapper';
import {ColumnsType} from 'antd/lib/table';
import {getNoun} from '../../utils/functions/getNoun';
import {menuPageColumns} from './components/columns';
import {authInfoSelect} from '../../entities/auth';
import {useSelector} from 'react-redux';
import {cssOverride, defaultInventCategory} from '../../utils/const';

moment().format();

const uniqueByKeys = (array, keys) => {
	const seen = new Set();
	return array.filter((item) => {
		const key = keys.map((k) => item[k]).join('|');
		return seen.has(key) ? false : seen.add(key);
	});
};

const MenuPage = () => {
	const [loading, setLoading] = useState<boolean>(true);
	const [menuData, setMenuData] = useState<any[]>([]);
	const [nameInventedArray, setNameInventedArray] = useState<any[]>([]);
	const [nameCategoriesArray, setNameCategoriesArray] = useState<any[]>([]);
	const {shop} = useSelector(authInfoSelect);
	const [filteredData, setFilteredData] = useState<any[]>([]);
	const hasFetchedRef = useRef(false);

	useEffect(() => {
		setFilteredData(menuData);
	}, [menuData]);

	useEffect(() => {
		if (loading && !hasFetchedRef.current && shop) {
			hasFetchedRef.current = true;
			setLoading(false);
			const menuUrl = `${process.env.REACT_APP_API_URL}/shops/${shop?.id}/menu`;
			const url = `${process.env.REACT_APP_API_URL}/shops/${shop?.id}/inventedCategory/items`;
			Promise.all([
				fetch(url, {
					headers: {
						accept: 'application/json',
						Authorization: `${localStorage.getItem('accessToken')}`,
						'Content-Type': 'application/json',
					},
				})
					.then((res) => res.json())
					.catch(() => []),
				fetch(menuUrl, {
					headers: {
						accept: 'application/json',
						Authorization: `${localStorage.getItem('accessToken')}`,
						'Content-Type': 'application/json',
					},
				})
					.then((res) => res.json())
					.catch(() => []),
			]).then(([inventedGroupsData, data]) => {
				if (data && Array.isArray(data) && inventedGroupsData && data.length > 0) {
					const updatedData = data.map((item) => {
						const {CATCODE: catcode} = item;
						let indexInvent = _.findIndex(inventedGroupsData, {
							category_id: catcode,
						});

						if (indexInvent !== -1) {
							return {
								...item,
								...inventedGroupsData[indexInvent].invent,
							};
						} else {
							return {...item, ...defaultInventCategory(shop.id)};
						}
					});
					const inventedCategoriesNameArray = _(updatedData)
						.map((i) => i.name_invented)
						.uniq()
						.map((o) => ({
							text: o,
							value: o,
						}))
						.value();

					const categoriesNameArray = _(updatedData)
						.map((i) => i.CATEGORY)
						.uniq()
						.map((o) => ({
							text: o,
							value: o,
						}))
						.value();

					setNameInventedArray(inventedCategoriesNameArray);
					setNameCategoriesArray(categoriesNameArray);
					setMenuData(uniqueByKeys(updatedData, ['CATID', 'ID']));
				}
			});
		}
	}, [loading, shop]);

	const columns: ColumnsType = menuPageColumns(nameInventedArray, nameCategoriesArray);

	return loading ? (
		<PuffLoader color='#E65E20' cssOverride={cssOverride} />
	) : (
		<Wrapper>
			<Header>
				<Title>
					Позиций в меню
					<SubTitle>
						{menuData ? getNoun(menuData.length, 'ед.', 'ед.', 'ед.') : 'нет товаров'}
					</SubTitle>
				</Title>
			</Header>
			<TableWrapper
				data={filteredData}
				loading={loading}
				columns={columns}
				setFilteredData={setFilteredData}
			/>
		</Wrapper>
	);
};

export default MenuPage;

const Wrapper = styled.div`
	min-width: 100%;
	height: 80%h;
	background-color: #fff;
	padding: 16px 29px 16px 128px;
`;

const Header = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
`;

const Title = styled.div`
	display: flex;
	flex-direction: column;
	font-weight: 600;
	font-size: 18px;
	line-height: 26px;
	letter-spacing: 0.02em;
	color: #000000;
`;

const SubTitle = styled.span`
	font-weight: 500;
	font-size: 13px;
	line-height: 26px;
	letter-spacing: 0.02em;
	color: #999999;
`;
